import React from 'react';
import type { ReactElement } from 'react';
import { PropertyTypesFilter } from './PropertyTypesFilter';
import { propertyTypesForSelectElement } from '../../../../shared/model/constants/propertyTypes';
import { FilterPillButton } from './FilterPillButton';
import type { PropertyType } from '../../../../shared/model/tsTypes';
import { FilterPillButtonSheet } from './FilterPillButtonSheet';
import useMedia from '../../../../shared/useMedia';

export interface FilterPillPropertyTypesProps {
  selectedPropertyTypes: Array<PropertyType['id']>;
  initialPropertyTypes: Array<PropertyType['id']>;
  onChange: (newValue: Array<PropertyType['id']>) => void;
  onFilterPillClose: () => void;
  onReset?: () => void;
  handleSearchOnClick: (onClose?: () => void) => void;
  trackPillClick: () => void;
}

export const getPillLabel = (propertyTypes: Array<PropertyType['id']>): string | undefined => {
  const noOfPropertyTypes = propertyTypes.length;

  if (noOfPropertyTypes === 0) {
    return undefined;
  }

  if (noOfPropertyTypes === 1) {
    return '1 Property type';
  }

  return `${noOfPropertyTypes} Property types`;
};

export const FilterPillPropertyTypes = ({
  selectedPropertyTypes,
  initialPropertyTypes,
  onChange,
  onReset,
  onFilterPillClose,
  handleSearchOnClick,
  trackPillClick,
}: FilterPillPropertyTypesProps): ReactElement => {
  const maybePillLabel = getPillLabel(initialPropertyTypes);
  const { isMediumScreen, isLargeScreen } = useMedia();

  return !isMediumScreen && !isLargeScreen ? (
    <FilterPillButtonSheet
      buttonLabel={maybePillLabel ?? 'Property type'}
      sheetLabel="Property type"
      selected={!!maybePillLabel}
      onReset={onReset}
      onFilterPillClose={onFilterPillClose}
      handleSearchOnClick={handleSearchOnClick}
      onFilterPillOpen={() => {
        trackPillClick();
      }}
      filter={
        <PropertyTypesFilter
          options={propertyTypesForSelectElement}
          values={selectedPropertyTypes}
          onChange={onChange}
          showDivider={false}
          hideHeading
        />
      }
    />
  ) : (
    <FilterPillButton
      label={maybePillLabel ?? 'Property type'}
      selected={!!maybePillLabel}
      onReset={onReset}
      onFilterPillClose={onFilterPillClose}
      onFilterPillOpen={() => {
        trackPillClick();
      }}
      handleSearchOnClick={handleSearchOnClick}
      popOverPlacement="bottom-start"
    >
      <PropertyTypesFilter
        options={propertyTypesForSelectElement}
        values={selectedPropertyTypes}
        hideHeading
        showDivider={false}
        onChange={onChange}
      />
    </FilterPillButton>
  );
};
